import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'deletedAgentIconLabel'
	| 'deletedAgent'
	| 'unavailableAgentStartNewChatButton'
	| 'noAgentPermissionIconLabel'
	| 'noAgentPermission';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		deletedAgentIconLabel: {
			id: 'ai-mate.chat-input.deleted-agent-icon-label',
			defaultMessage: 'Agent deleted',
			description:
				'Accessibility label (aria-label) for an icon or visual indicator displayed in the chat input area within the AI conversation interface when the AI agent associated with the current conversation has been deleted. Shown as a screen reader announcement when the icon is focused or hovered. The purpose is to provide accessible information about the agent deletion status for users with assistive technologies, indicating that the agent is no longer available.',
		},
		deletedAgent: {
			id: 'ai-mate.chat-input.deleted-agent-warning',
			defaultMessage: 'This Agent has been deleted.',
			description:
				'Warning message displayed in a notification, alert, or banner in the chat input area within the AI conversation interface when a user attempts to interact with a conversation that was associated with an AI agent that has since been deleted. Shown as a warning message. The purpose is to clearly communicate why the conversation cannot continue with the original agent and guide the user to start a new conversation.',
		},
		unavailableAgentStartNewChatButton: {
			id: 'ai-mate.chat-input.deleted-agent-start-new-chat',
			defaultMessage: 'Start new chat',
			description:
				'Button label displayed on a button that appears when the AI agent has been deleted, allowing users to begin a new conversation. Shown as the text on a button in a warning dialog or banner. When clicked, it clears the current conversation context and starts a fresh chat session. The purpose is to provide users with a clear path forward when their previous agent is no longer available.',
		},
		noAgentPermissionIconLabel: {
			id: 'ai-mate.chat-input.no-agent-permission-icon-label',
			defaultMessage: 'No agent permission',
			description:
				'Accessibility label (aria-label) for an icon or visual indicator displayed in the chat input area within the AI conversation interface when the user does not have permission to use the AI agent. Shown as a screen reader announcement when the icon is focused or hovered. The purpose is to provide accessible information about the permission status for users with assistive technologies.',
		},
		noAgentPermission: {
			id: 'ai-mate.chat-input.no-agent-permission-warning',
			defaultMessage: "You don't have permission to use this Agent.",
			description:
				'Warning message displayed in a notification, alert, or banner in the chat input area within the AI conversation interface when a user attempts to interact with a conversation that requires permissions they do not have. Shown as a warning message. The purpose is to clearly communicate why the conversation cannot continue and guide the user to start a new conversation.',
		},
	});

export default message;
